import { useNavigate } from 'react-router-dom';
import { AT_CONSOLES, type ATConsoleConfig } from './ATHub.constants';
import {
  ATHubGlobal,
  Root,
  TopBar,
  BackBtn,
  BrandDot,
  BrandName,
  BrandSub,
  HubWrap,
  HubLabel,
  HubTitle,
  HubSub,
  CardsRow,
  ConsoleCard,
  LiveDot,
  CardStatusRow,
  CardStatusText,
  CardMetric,
  ConsoleName,
  ConsoleTagline,
  FeatureList,
  Feature,
  FeatureName,
  ComingSoonTag,
  EnterBtn,
  ComingSoonStrip,
  StripLeft,
  StripIcon,
  StripName,
  StripDesc,
  StripBadge,
} from './ATHub.styles';

// ─── Console card ────────────────────────────────────────────────────────────

interface ConsoleCardItemProps {
  config: ATConsoleConfig;
  onEnter: (id: ATConsoleConfig['id']) => void;
}

const ConsoleCardItem = ({ config, onEnter }: ConsoleCardItemProps) => (
  <ConsoleCard $accent={config.accent}>
    <CardStatusRow>
      <LiveDot $color={config.accent} />
      <CardStatusText>{config.statusLabel}</CardStatusText>
      <CardMetric $accent={config.accent}>{config.metricLabel}</CardMetric>
    </CardStatusRow>

    <ConsoleName $accent={config.accent}>{config.name}</ConsoleName>
    <ConsoleTagline>{config.tagline}</ConsoleTagline>

    <FeatureList>
      {config.features.map((feat) => (
        <Feature key={feat.name} $accent={config.accent} $dim={feat.comingSoon}>
          <FeatureName $accent={config.accent} $dim={feat.comingSoon}>
            {feat.name}
          </FeatureName>
          · {feat.description}
          {feat.comingSoon && <ComingSoonTag>Próximamente</ComingSoonTag>}
        </Feature>
      ))}
    </FeatureList>

    <EnterBtn
      $accent={config.accent}
      disabled={config.disabled}
      onClick={() => !config.disabled && onEnter(config.id)}
    >
      <span>{config.enterLabel}</span>
      <span>→</span>
    </EnterBtn>
  </ConsoleCard>
);

// ─── ATHub ───────────────────────────────────────────────────────────────────

export const ATHub = () => {
  const navigate = useNavigate();

  const handleEnter = (id: ATConsoleConfig['id']) => {
    navigate(`/algorithmic-trading/${id}`);
  };

  return (
    <>
      <ATHubGlobal />
      <Root>
        <TopBar>
          <BackBtn onClick={() => navigate('/launch')}>← Launcher</BackBtn>
          <BrandDot />
          <div>
            <BrandName>AT Console</BrandName>
            <BrandSub>· Algorithmic Trading</BrandSub>
          </div>
        </TopBar>

        <HubWrap>
          <HubLabel>Módulo de Trading Algorítmico</HubLabel>
          <HubTitle>Tus consolas</HubTitle>
          <HubSub>Cada consola opera de forma independiente sobre el motor de pricing.</HubSub>

          <CardsRow>
            {AT_CONSOLES.filter((c) => !c.hidden).map((config) => (
              <ConsoleCardItem key={config.id} config={config} onEnter={handleEnter} />
            ))}
          </CardsRow>

          <ComingSoonStrip>
            <StripLeft>
              <StripIcon>⊘</StripIcon>
              <StripName>Consola 3</StripName>
              <StripDesc>— En definición. Se integrará en una próxima fase.</StripDesc>
            </StripLeft>
            <StripBadge>Próximamente</StripBadge>
          </ComingSoonStrip>
        </HubWrap>
      </Root>
    </>
  );
};
